import { Component } from '@angular/core';

import { DashboardComponent } from '../../dashboard/dashboard.component';
import { HeaderDashboardComponent } from '../components/header-dashboard/header-dashboard.component';

@Component({
  selector: 'app-carto-layout',
  imports: [DashboardComponent, HeaderDashboardComponent],
  templateUrl: './carto-layout.component.html',
})
export class CartoLayoutComponent {}
